import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["relative"]
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "data" }
const _hoisted_4 = { class: "checkbox-wrapper" }
const _hoisted_5 = { class: "remove" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Divider = _resolveComponent("Divider")
  const _component_ObjectViewer = _resolveComponent("ObjectViewer")
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_Popconfirm = _resolveComponent("Popconfirm")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_AddSample = _resolveComponent("AddSample")

  return (_openBlock(), _createElementBlock("div", {
    class: "dataset-view",
    relative: $data.loading
  }, [
    ($data.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          class: "loading",
          large: ""
        }))
      : (!!$props.datasetName)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Checkbox, {
                "model-value": $data.selected.size === $data.items.length,
                indeterminate: $data.selected.size > 0 && $data.selected.size !== $data.items.length,
                disabled: !$options.can_add,
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                onChange: $options.toogleCheckboxes
              }, null, 8 /* PROPS */, ["model-value", "indeterminate", "disabled", "onChange"]),
              _createVNode(_component_Button, {
                disabled: !$options.can_add,
                class: "add-sample",
                onClick: $options.openAddSample
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("Add Sample")
                ])),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled", "onClick"])
            ]),
            _createVNode(_component_Divider, { m: "0" }),
            _createVNode(_component_ScrollBar, { class: "scroller" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item,
                      class: "object"
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_Checkbox, {
                          "model-value": $data.selected.has(item.id),
                          onChange: $event => ($data.selected.has(item.id) ? $data.selected.delete(item.id) : $data.selected.add(item.id))
                        }, null, 8 /* PROPS */, ["model-value", "onChange"])
                      ]),
                      _createVNode(_component_ObjectViewer, {
                        object: item.input,
                        "root-name": item.id,
                        "expanded-keys": $data.expanded_keys
                      }, null, 8 /* PROPS */, ["object", "root-name", "expanded-keys"]),
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_Popconfirm, {
                          width: "max-content",
                          "confirm-button-text": "Yes",
                          "cancel-button-text": "No",
                          title: "Delete sample?",
                          onConfirm: $event => ($options.remove(item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_IconAsButton, {
                              icon: "trash-04",
                              hoverable: "",
                              size: "2rem",
                              color: "--gray-500"
                            })
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onConfirm"])
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _: 1 /* STABLE */
            })
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
    _createVNode(_component_AddSample, {
      ref: "sample",
      vars: $data.vars,
      "dataset-name": $props.datasetName,
      onSave: $options.addSample
    }, null, 8 /* PROPS */, ["vars", "dataset-name", "onSave"])
  ], 8 /* PROPS */, _hoisted_1))
}